import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import TagManager from 'react-gtm-module'

const gtmId = process.env.REACT_APP_GTM_ID
if (gtmId) {
  const tagManagerArgs = {
    gtmId: gtmId,
    auth: process.env.REACT_APP_GTM_AUTH,
    preview: process.env.REACT_APP_GTM_PREVIEW,
  }
  TagManager.initialize(tagManagerArgs)
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
